import { emailValidationPattern } from "tools/validations/index";

export const isNonEmptyValue = (value: unknown) =>
  !!value?.toString()?.trim()?.length;
export const isNonEmptyEmailValue = (value: unknown) => {
  if (!value || typeof value !== "string") {
    return false;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 && emailValidationPattern.test(trimmed);
};

export const isNumber = (val: unknown): val is number =>
  typeof val === "number";
